import { inherits as _inherits, createClass as _createClass, defineProperty as _defineProperty, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import Popover from 'react-bootstrap/Popover';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { i18n } from '../i18n/translate.js';
import { ConfirmationModal } from './ConfirmationModal/index.js';
import { Button } from './Button/index.js';
import { storage } from '../utils/Storage.js';
import { sanitizeUrl } from '@braintree/sanitize-url';
import { FAIcon } from './fa-icon/component.js';
import { WindowHelperWrapper } from '../utils/WindowHelper.js';
var ReportDownload = /*#__PURE__*/function (_React$Component) {
  function ReportDownload() {
    var _this;
    _classCallCheck(this, ReportDownload);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ReportDownload, [].concat(args));
    _defineProperty(_this, "handleDownload", function () {
      storage.setItem('suppressLoadingClass', true);
    });
    return _this;
  }
  _inherits(ReportDownload, _React$Component);
  return _createClass(ReportDownload, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.downloadUrl && this.props.downloadUrl) {
        this.handleDownload();
        WindowHelperWrapper(window).open(sanitizeUrl(this.props.downloadUrl), '_blank');
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        closeTimeoutModal = _this$props.closeTimeoutModal,
        downloadAction = _this$props.downloadAction,
        downloadLabel = _this$props.downloadLabel,
        downloadIcon = _this$props.downloadIcon,
        downloadParams = _this$props.downloadParams,
        downloadUrl = _this$props.downloadUrl,
        downloadProcessing = _this$props.downloadProcessing,
        downloadTimedOut = _this$props.downloadTimedOut;
      if (downloadProcessing) {
        return /*#__PURE__*/React.createElement("span", null, i18n.t('Building File...'));
      } else if (downloadUrl) {
        return /*#__PURE__*/React.createElement("a", {
          download: true,
          href: sanitizeUrl(downloadUrl),
          onClick: this.handleDownload
        }, downloadIcon && /*#__PURE__*/React.createElement(FAIcon, {
          icon: downloadIcon
        }), downloadLabel || i18n.t('Download'));
      } else if (downloadTimedOut) {
        return /*#__PURE__*/React.createElement(ConfirmationModal, {
          title: i18n.t('Report Sent'),
          onConfirm: closeTimeoutModal,
          canClose: true,
          show: true,
          confirmOnly: true
        }, /*#__PURE__*/React.createElement("div", null, i18n.t("Seems that it's taking longer than we expected to create your report. Once your report is ready we'll send you an email with a link to download it.")));
      } else {
        var overlay = /*#__PURE__*/React.createElement(Popover, {
          id: "email-report"
        }, i18n.t('Click to download report'));
        return /*#__PURE__*/React.createElement(React.Fragment, null, downloadAction && /*#__PURE__*/React.createElement(OverlayTrigger, {
          placement: "top",
          overlay: overlay
        }, /*#__PURE__*/React.createElement(Button, {
          label: /*#__PURE__*/React.createElement("span", null, downloadLabel || i18n.t('Download Results')),
          icon: downloadIcon || 'cloud-arrow-down',
          style: "link",
          size: "compact",
          onClick: function onClick() {
            return downloadAction(downloadParams);
          }
        })));
      }
    }
  }]);
}(React.Component);
_defineProperty(ReportDownload, "propTypes", {
  downloadAction: PropTypes.func,
  downloadIcon: PropTypes.string,
  downloadLabel: PropTypes.string,
  downloadParams: PropTypes.any,
  downloadUrl: PropTypes.string,
  downloadProcessing: PropTypes.bool,
  closeTimeoutModal: PropTypes.func,
  downloadTimedOut: PropTypes.bool
});
ReportDownload.displayName = "ReportDownload";
export { ReportDownload };